import store from '@/components/store/store'

// ====== Словари прав ======
export const permissionLabels = {
  // Контакты
  'client.view': 'Просмотр',
  'client.create': 'Создание',
  'client.edit': 'Редактировать / Удалять',
  // Абонементы
  'certificates.view': 'Просмотр',
  'certificates.create': 'Создание',
  'certificates.edit': 'Редактировать / Удалять',
  // Сотрудники
  'users.view': 'Просмотр',
  'users.create': 'Создание',
  'users.edit': 'Редактировать / Удалять',
  // Услуги
  'service.view': 'Просмотр',
  'service.create': 'Создание',
  'service.edit': 'Редактировать / Удалять',
  // Расписание
  'schedule.view': 'Просмотр',
  'schedule.create': 'Создание',
  'schedule.edit': 'Редактировать / Удалять',
  // Платежи
  'payments.view': 'Просмотр',
  'payments.create': 'Создание',
  'payments.edit': 'Редактировать / Удалять',
  // Записи
  'appointments.view': 'Просмотр',
  'appointments.create': 'Создание',
  'appointments.complete': 'Закрывать запись',
  'appointments.edit': 'Редактировать / Удалять',
  // Локации
  'locations.view': 'Просмотр',
  'locations.edit': 'Редактировать / Удалять',
  // Настройки
  'settings.edit': 'Общие настройки',
  'custom-fields.edit': 'Доп. поля',
}

// ====== Группы разделов ======
export const permissionGroups = {
  'Контакты': ['client.view', 'client.create', 'client.edit'],
  'Абонементы': ['certificates.view', 'certificates.create', 'certificates.edit'],
  'Сотрудники': ['users.view', 'users.create', 'users.edit'],
  'Расписание': ['schedule.view', 'schedule.edit', 'schedule.create'],
  'Транзакции': ['payments.view', 'payments.create', 'payments.edit'],
  'Записи': ['appointments.view', 'appointments.create', 'appointments.edit', 'appointments.complete'],
  'Услуги': ['service.view', 'service.create', 'service.edit'],
  'Локации': ['locations.view', 'locations.edit'],
  'Настройки': ['settings.edit', 'custom-fields.edit']
}

// ====== Сопоставление маршрутов и групп ======
export const routeAccessMap = {
  // --- Расписание ---
  '/': 'Расписание',
  '/schedules': 'Расписание',
  // --- Контакты ---
  '/contacts': 'Контакты',
  // --- Абонементы ---
  '/certificates': 'Абонементы',
  // --- Сотрудники ---
  '/employees': 'Сотрудники',
  // --- Услуги ---
  '/services': 'Услуги',
  // --- Транзакции ---
  '/client-payments': 'Транзакции',
  // --- Локации ---
  '/branches': 'Локации',
  // --- Настройки ---
  '/custom-fields': 'Пользваотельские поля',
  '/settings': 'Общие настройки',
  '/messengers': 'Месендежеры'
}

// ====== Базовые ======
const getUser = () => store.state.auth.user

export function isAdmin() {
  const user = getUser();
  return !!(user && (user.is_admin || user.permissions === '*'))
}

export function hasPermission(permission) {
  const user = getUser()
  if (!user || !user.permissions) return false
  if (isAdmin()) return true
  return Array.isArray(user.permissions) && user.permissions.includes(permission)
}

export function hasAnyPermission(permissionList = []) {
  return permissionList.some(p => hasPermission(p))
}

export function hasAllPermissions(permissionList = []) {
  return permissionList.every(p => hasPermission(p))
}

// ====== Разделы (меню и страницы) ======

/**
 * Проверяет, есть ли у пользователя доступ к разделу (группе).
 * Используется для отображения пунктов меню и доступа к роутам.
 */
export function canAccessSection(groupName) {
  const user = getUser()
  if (!user || !user.permissions) return false
  if (isAdmin()) return true
  const groupPermissions = permissionGroups[groupName] || []
  return hasAnyPermission(groupPermissions)
}

/**
 * Возвращает список всех доступных разделов для текущего пользователя
 */
export function getAccessibleSections() {
  const access = {}
  for (const sectionName of Object.keys(permissionGroups)) {
    access[sectionName] = canAccessSection(sectionName)
  }
  return access
}

// ====== Проверки по действиям ======
export function canView(groupName) {
  return hasPermissionFromGroup(groupName, '.view')
}

export function canCreate(groupName) {
  return hasPermissionFromGroup(groupName, '.create')
}

export function canEdit(groupName) {
  return hasPermissionFromGroup(groupName, '.edit')
}

export function canDelete(groupName) {
  return hasPermissionFromGroup(groupName, '.delete')
}

export function canManage(groupName) {
  return hasPermissionFromGroup(groupName, '.manage')
}

/**
 * Проверка наличия конкретного действия (view, edit, delete...) в рамках раздела
 */
function hasPermissionFromGroup(groupName, suffix) {
  const permissions = permissionGroups[groupName] || []
  const filtered = permissions.filter(p => p.endsWith(suffix))
  return hasAnyPermission(filtered)
}

export class hasGroupAccess {
}
